var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3015",
    "data-name": "Rectangle 3015",
    width: 40,
    height: 40,
    fill: "#f9f9f9",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5882",
    "data-name": "Group 5882",
    transform: "translate(9.829 9.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10004",
    "data-name": "Path 10004",
    d: "M10.173,0h-.005A10.164,10.164,0,0,0,1.936,16.132L.669,19.91l3.909-1.25A10.169,10.169,0,1,0,10.173,0Z",
    transform: "translate(0)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10005",
    "data-name": "Path 10005",
    d: "M14.47,13a2.7,2.7,0,0,1-1.876,1.38c-.5.109-1.152.2-3.348-.736a12.089,12.089,0,0,1-4.759-4.3A5.655,5.655,0,0,1,3.352,6.39a3.153,3.153,0,0,1,.977-2.38,1.37,1.37,0,0,1,.977-.351c.118,0,.225.006.32.011.281.012.422.029.607.483.231.569.792,1.972.859,2.116a.594.594,0,0,1,.041.529,1.691,1.691,0,0,1-.309.449c-.141.166-.275.293-.416.472a.467.467,0,0,0-.112.609A8.655,8.655,0,0,0,7.847,10.3a7,7,0,0,0,2.241,1.415.594.594,0,0,0,.674-.109,11.813,11.813,0,0,0,.747-1.012.527.527,0,0,1,.686-.213c.258.092,1.624.782,1.9.926s.466.213.534.334A2.489,2.489,0,0,1,14.47,13Z",
    transform: "translate(1.248 1.189)",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7ada23541a3638940f96669db783f52e.svg";
export { ForwardRef as ReactComponent };